import { lazy } from 'react';

export const authModalComponentByType = {
  EMAIL_SIGNUP: lazy(() =>
    import('./EmailSignup/EmailSignupModal').then((module) => ({
      default: module.EmailSignupModal,
    })),
  ),
  VERIFY_EMAIL: lazy(() =>
    import('./VerifyEmail/VerifyEmailModalContainer').then((module) => ({
      default: module.VerifyEmailModalContainer,
    })),
  ),
  VM_EMAIL_VERIFICATION: lazy(() =>
    import('./VMEmailVerification/VMEmailVerificationModal').then((module) => ({
      default: module.VMEmailVerificationModal,
    })),
  ),
  LOGIN: lazy(() =>
    import('./Login/LoginModal').then((module) => ({
      default: module.LoginModal,
    })),
  ),
  SIGNUP: lazy(() =>
    import('./Signup/SignupModal').then((module) => ({
      default: module.SignupModal,
    })),
  ),
  FORGOT_PASSWORD: lazy(() =>
    import('./ForgotPassword/ForgotPasswordModalContainer').then((module) => ({
      default: module.ForgotPasswordModalContainer,
    })),
  ),
  FINISH_OAUTH_SIGNUP: lazy(() =>
    import('./FinishOauthSignup/FinishOauthSignupModal').then((module) => ({
      default: module.FinishOauthSignupModal,
    })),
  ),
  // TODO: move to #/auth/
  VM_POST_VERIFICATION_TOUR: lazy(() =>
    import('#/components/VMOnboardingModals/VMOnboardingModals').then(
      (module) => ({ default: module.VMOnboardingModals }),
    ),
  ),
  VM_POST_VERIFICATION_INFORMATION_REQUIRED: lazy(() =>
    import('#/modules/auth/modals/VMPostVerificationWelcome/VMPostVerificationWelcomeModalContainer').then(
      (module) => ({ default: module.VMPostVerificationWelcomeModalContainer }),
    ),
  ),
  VM_ORG_ADMIN_WELCOME: lazy(() =>
    import('#/modules/auth/modals/VMOrgAdminWelcome/VMOrgAdminWelcomeModalContainer').then(
      (module) => ({ default: module.VMOrgAdminWelcomeModalContainer }),
    ),
  ),
} as const satisfies Record<string, unknown>;
